// extracted by mini-css-extract-plugin
export default {"resetButton":"ResetButton_resetButton__mPTXo","icon":"ResetButton_icon__hsQfo","iconRotate":"ResetButton_iconRotate__8uB3G","spinIcon":"ResetButton_spinIcon__Rtv0L"};